export default __webpack_public_path__ + "static/media/download-icon.2c364475.svg";